import type { Row, RowSelectionState } from "@tanstack/react-table";

/** Fallback `searchKeys` when the consumer omits them (email-only filter). */
export const ORGANISM_DEFAULT_SEARCH_KEYS = ["email"] as const;

export function selectedIdsToRowSelection(ids: string[]): RowSelectionState {
  return Object.fromEntries(ids.map((id) => [id, true]));
}

export function rowSelectionToSelectedIds(
  selection: RowSelectionState
): string[] {
  return Object.keys(selection).filter((id) => selection[id]);
}

export function resolveEnableRowSelection<TData extends { id: string }>(
  enableRowSelection: boolean | ((row: TData) => boolean) | undefined
): boolean | ((row: Row<TData>) => boolean) {
  if (enableRowSelection === undefined) return true;
  if (typeof enableRowSelection === "function") {
    return (row: Row<TData>) => enableRowSelection(row.original);
  }
  return enableRowSelection;
}

export function resolveOrganismSearchKeys<TData extends { id: string }>(
  keys: (keyof TData & string)[] | undefined
): (keyof TData & string)[] {
  if (keys?.length) {
    return keys;
  }
  return [...ORGANISM_DEFAULT_SEARCH_KEYS] as (keyof TData & string)[];
}
